import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { useMe } from "@crehana/auth";
import { cookies, customLocalStorage } from "@crehana/utils";
import { COOKIES_COMPASS_THEME_KEY } from "./constants.js";
import { UpdateUserThemePreferenceDocument } from "./graphql/UpdateUserThemePreference.v2.generated.js";
const UIThemeContext = /*#__PURE__*/ createContext({
    theme: 'light',
    isDark: false,
    toggleTheme: ()=>{}
});
const UIThemeProvider = ({ children })=>{
    const { me } = useMe();
    const initialTheme = 'light';
    const [{ theme, isDark }, setState] = useState({
        theme: initialTheme,
        isDark: false
    });
    const [updateUserThemePreferenceMutation] = useMutation(UpdateUserThemePreferenceDocument);
    const toggleCompassTheme = ({ to })=>{
        const add = 'light' === to ? 'tw-light' : 'tw-dark';
        const remove = 'light' === to ? 'tw-dark' : 'tw-light';
        document.querySelector('html')?.classList?.add?.(add);
        document.querySelector('html')?.classList?.remove?.(remove);
    };
    useEffect(()=>{
        if (me?.settings) {
            const darkMode = false;
            setState({
                theme: darkMode ? 'dark' : 'light',
                isDark: !!darkMode
            });
        }
    }, [
        me
    ]);
    useEffect(()=>{
        if (isDark) {
            customLocalStorage.setItem('crehana-dark-mode', 'true');
            toggleCompassTheme({
                to: 'dark'
            });
            cookies.setCookie(COOKIES_COMPASS_THEME_KEY, 'dark', 1825);
        } else {
            customLocalStorage.removeItem('crehana-dark-mode');
            toggleCompassTheme({
                to: 'light'
            });
            cookies.setCookie(COOKIES_COMPASS_THEME_KEY, 'light', 1825);
        }
    }, [
        isDark
    ]);
    const toggleTheme = (args)=>{
        const { shouldSaveThemePreferenceMutation = true } = args || {};
        const newTheme = 'light' === theme ? 'dark' : 'light';
        const darkMode = 'dark' === newTheme;
        setState({
            theme: newTheme,
            isDark: darkMode
        });
        if (shouldSaveThemePreferenceMutation) updateUserThemePreferenceMutation({
            variables: {
                darkMode
            }
        });
    };
    return /*#__PURE__*/ jsx(UIThemeContext.Provider, {
        value: {
            theme,
            isDark,
            toggleTheme
        },
        children: children
    });
};
const useUITheme = ()=>{
    const context = useContext(UIThemeContext);
    if (void 0 === context) throw new Error('useUITheme must be used within a UITheme provider. To include it with LayoutV2, the prop withUITheme must be true.');
    return context;
};
const UITheme_UIThemeProvider = UIThemeProvider;
export default UITheme_UIThemeProvider;
export { UIThemeProvider, useUITheme };
